// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const ConnectRequiredInfoDoc: MarkdocTagRegistration = {
  tag: 'connect-required-info-doc',
  component: 'ConnectRequiredInfoDoc',
  children: [
    'heading',
    'paragraph',
    'image',
    'table',
    'tag',
    'fence',
    'blockquote',
    'partial',
    'connect-required-info-doc',
  ],
};
